import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

interface UseReadPosition {
    scrolledHalfway: boolean;
    scrolledToBottom: boolean;
}

const useReadPosition = (): UseReadPosition => {
    const [scrolledHalfway, setScrolledHalfway] = useState(false);
    const [scrolledToBottom, setScrolledToBottom] = useState(false);
    const isServerSide = typeof window === 'undefined';

    useEffect(() => {
        const updatePosition = () => {
            const offset = window.scrollY / (document.body.offsetHeight - window.innerHeight);
            if (offset > 0.5) {
                if (!scrolledHalfway) {
                    setScrolledHalfway(true);
                }
                if (offset > 0.95 && !scrolledToBottom) {
                    setScrolledToBottom(true);
                }
            }
        };
        if (!isServerSide) {
            window.addEventListener('scroll', debounce(updatePosition, 500));
        }

        return () => {
            if (!isServerSide) {
                window.removeEventListener('scroll', debounce(updatePosition, 500));
            }
        };
    }, [isServerSide, scrolledHalfway, scrolledToBottom]);

    return { scrolledHalfway, scrolledToBottom };
};

export default useReadPosition;
